module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("申請移轉")]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  }, [_c('table', {
    staticClass: "table table-bordered  table-nonfluid table-responsive"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("姓名 : ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.personal.org_name) + "(" + _vm._s(_vm.personal.org_mid) + ")\n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("信箱 : ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.personal.email))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("推薦人移轉類型 : ")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transferType),
      expression: "transferType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.transferType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.transferCategory), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                                " + _vm._s(option.text) + "\n                            ")])
  }))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("預計移轉對象 : ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.targetOrgMid),
      expression: "targetOrgMid"
    }],
    attrs: {
      "type": "numbeer"
    },
    domProps: {
      "value": (_vm.targetOrgMid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.targetOrgMid = $event.target.value
      }
    }
  }), _vm._v(" (請填寫會員編號)\n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("具體申請是由 : ")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "任一申請類型，請都填寫具體事由再進行送出",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.applyTransfer()
      }
    }
  }, [_vm._v("確認申請")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("取消")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-460a9050"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member/Transfer.vue
// module id = 298
// module chunks = 1